import { isAxiosError } from 'axios'
import { t } from 'i18next'
import { enqueueSnackbar } from 'notistack'

export type ToRestErrorMessage = (responseData: unknown) => string | undefined

export const toRestErrorResponseData = (error: unknown): unknown =>
  isAxiosError(error) ? error.response?.data : undefined

export const enqueueSnackbarForRestError = (
  error: unknown,
  toMessage?: ToRestErrorMessage,
): void => {
  const apiMessage: string | undefined = toMessage?.(toRestErrorResponseData(error))

  if (apiMessage !== undefined) {
    enqueueSnackbar(apiMessage, { variant: 'error' })

    return
  }

  const title: string = t('error.serverError', { ns: 'providers/tanstackQuery' })
  const message: string = error instanceof Error ? error.message : String(error)

  enqueueSnackbar(`${title}: ${message}`, { variant: 'error' })
}
